import isEmpty from 'lodash/isEmpty';

import linkVariants from '@/helpers/auth-forms/linkVariants';
import variants from '@/helpers/auth-forms/variants';
import buttonVariants from '@/helpers/buttons/variants';
import { getAppUrl } from '@/helpers/url';

export default {
  props: {
    redirectToDashboard: {
      default: false,
      type: Boolean,
    },
    variant: {
      default: null,
      type: String,
    },
  },

  data() {
    return {
      isEmailRegistered: false,
    };
  },

  computed: {
    buttonVariant() {
      if (this.variant in buttonVariants) {
        return this.variant;
      }

      return 'ocean';
    },
    currentClass() {
      return variants[this.variant] ?? null;
    },
    cxWelcomeUrl() {
      return getAppUrl('/cx/welcome/');
    },
    dashboardUrl() {
      return getAppUrl('/');
    },
    forgotPasswordUrl() {
      return getAppUrl('/auth/forgot-password');
    },
    linkVariant() {
      if (linkVariants[this.variant]) {
        return linkVariants[this.variant];
      }

      return linkVariants.primary;
    },
  },

  methods: {
    hasEmailConflict(error) {
      this.isEmailRegistered = error.response?.status === 409
        && !isEmpty(error.response.data?.data?.email);

      return this.isEmailRegistered;
    },
    resetEmailConflict() {
      this.isEmailRegistered = false;
    },
  },
};
